<template>
  <div class="problem-content">
    <div v-show="isEdit" class="comment-edit">
      <div class="comment-edit_editor">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item label="内容" prop="content">
            <vditor-editor v-model="form.content" :height="400" :width="450" />
          </a-form-model-item>
        </a-form-model>
      </div>
      <div>
        <a-button type="primary" style="margin-right: 16px" @click="onSubmit">确定</a-button>
        <a-button @click="onClose">取消</a-button>
      </div>
    </div>
    <div v-for="(comment, index) in ticketInfo.reply" :key="index">
      <div :style="{ marginBottom: '15px' }">
        <a-avatar slot="avatar" :src="comment.reporter.avatarUrl" :size="40" />
        <!-- 调整 avatar 大小为 60px -->
        <span style="margin-left: 10px; font-size: 13px; color: #999">{{ comment.reporter.nickName }}</span>
        <!-- 调整左边距为 10px -->
        <span slot="datetime">
          <a-tooltip :title="getFormattedTime(comment.createdTime)">
            <span style="font-size: 13px; color: #999">{{ ' 回复于 ' + getFormattedTime(comment.createdTime) }} </span>
          </a-tooltip>
        </span>
        <br />
        <div class="problem-content" style="padding-left: 55px">
          <vditor-preview width="200px" :content="buildContent(comment)" style="font-size: 16px" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ticketReply } from '@/api/event/problem';

import VditorEditor from '@/components/VditorEditor';
import VditorPreview from '@/components/VditorEditor/preview';

export default {
  components: { VditorEditor, VditorPreview },
  props: {
    ticketInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      comments: [],
      form: {
        content: ''
      },
      isEdit: false,
      rules: {
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {},
  methods: {
    getFormattedTime(createdTime) {
      return createdTime.substring(0, 19); // 提取从索引0开始的前19个字符（形如：YYYY-MM-DD HH:mm:ss）
    },
    buildContent(comment) {
      if (!comment || !Array.isArray(comment.images)) {
        // 检查comment对象是否存在或者comment.images是否为数组
        console.warn('comment对象或者comment.images不存在');
        return comment.desc;
      }
      let content = comment.desc;
      for (const image of comment.images) {
        const url = image;
        let cardString;

        if (image.includes('mp4')) {
          cardString = `![Screenrecording.mp4](${url})`;
        } else {
          cardString = `![image.png](${url})`;
        }

        content += cardString;
      }
      return content;
    },

    onSubmit() {
      const regex = /!\[.*\]\((https?:\/\/[^\s]+\.(?:png|jpe?g))\)/gi;
      const matches = Array.from(this.form.content.matchAll(regex));
      const imageLinks = [];
      for (const match of matches) {
        const link = match[1];
        imageLinks.push(link);
        this.form.content = this.form.content.replace(match[0], '');
      }
      const replyInfo = {
        desc: this.form.content.replace(/\n/g, ''),
        from: this.ticketInfo.from,
        createdTime: '',
        images: imageLinks,
        qiyuTicketId: this.ticketInfo.qiyuTicketId,
        reporter: {
          nickNanme: '',
          avatarUrl: ''
        },
        ticketId: this.ticketInfo.id
      };
      const localReplyList = this.ticketInfo;
      if (localReplyList.reply == null) {
        localReplyList.reply = [];
      }
      localReplyList.reply.push(replyInfo);
      ticketReply({ replyInfo })
        .then(res => {
          this.onClose();
          this.$emit('callback');
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onAddComment() {
      this.$refs.form.resetFields();
      this.form.content = '';
      this.isEdit = true;
    },

    onClose() {
      this.$refs.form.resetFields();
      this.form.content = '';
      this.isEdit = false;
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-comment-inner) {
  padding: 8px 0;
}

:deep(.vditor-reset) {
  width: auto;
}
:deep(.ant-form-item) {
  margin-bottom: 8px;
}
.problem-content {
  background: #fafafa;
}
.comment-edit {
  background: #fafafa;
  padding: 8px;
  padding-top: 0;
  margin-bottom: 16px;
  .comment-edit_editor {
    width: 960px;
  }
}
</style>
